import api_config from '@/api/config/_api_config'
import api from '@/api/api.js'

export default {
    getTresoreriePaiementAccess() {
        return api_config().post('/tresorerie/paiement-access', {},
            { med003_paiement_access_request: true }).then(response => response.data)
    },
    getTresorerieRemunerationAccess() {
        return api_config().post('/tresorerie/remuneration-access', {},
            { med003_access_request: true }).then(response => response.data)
    },
    getRemunerationsEnAttente(access_token) {
        return api.clinique().post('/remunerations-medecins/en-attente', {},
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    getRemunerationsEnAttenteV2(access_token) {
        return api.clinique().post('/remunerations-medecins/en-attente-v2', {},
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    getPatientsRemunerations(data, access_token) {
        return api.clinique().post('/remunerations-medecins/patients', { entree_ids: data.entree_ids },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    updateStatutRemunerations(data, access_token) {
        return api.clinique().post('/remunerations-medecins/statut', { statut: 'exportee', recu_import: data.recu_import },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    updateStatutRemunerationsV2(data, access_token) {
        return api.clinique().post('/remunerations-medecins/statut-v2', { statut: 'exportee', recu_import: data.recu_import },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    // Clôtures de consultation : rendent payables les lignes déjà importées.
    getCloturesEnAttente(access_token) {
        return api.clinique().post('/remunerations-medecins/clotures-en-attente', {},
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    },
    updateCloturesTransmises(data, access_token) {
        return api.clinique().post('/remunerations-medecins/clotures-statut', { recu_cloture: data.recu_cloture },
            { headers: { 'X-Tresorerie-Access': access_token }, med_access_scoped: true }).then(response => response.data)
    }
}
